

// import i18n from "i18next";

// import Backend from "i18next-xhr-backend";
// import LanguageDetector from "i18next-browser-languagedetector";
// import { initReactI18next } from "react-i18next";

// import accountAPI from "./apiCalls/accountAPI";

// const engOnly = ["US", "CA", "GB"]

// const resources = {}
// const response1 = {"AIR":"Air","ALL":"All","NEW":"New","HOLD":"Hold","PAGE":"Page","RAIL":"Rail","OCEAN":"Ocean","TRUCK":"Truck","ACTIVE":"Active","CANCEL":"Cancel","CUSTOM":"Custom","EXPORT":"Export","FILTER":"Filter","IMPORT":"Import","RECENT":"Recent","REJECT":"Reject","SEARCH":"SearchArchit","STATUS":"Status","TRANSIT":"Transit","COMPLETE":"Complete","IMPORTER":"Importer","CONTAINER":"Container","SHIPMENT_ID":"Shipment ID","ENTRY_NUMBER":"Entry Number","BILL_OF_LADING":"Bill Of Lading","PURCHASE_ORDER":"Purchase Order","SELECT_JOB_STATE":"Select Job State","SELECT_BROKER_NAME":"Select Broker Name","PRODUCT_DISCRIPTION":"Product Discritpion"}
// const response2 = {"AIR":"Air","ALL":"All","NEW":"New","HOLD":"Hold","PAGE":"Page","RAIL":"Rail","OCEAN":"Ocean","TRUCK":"Truck","ACTIVE":"Active","CANCEL":"Cancel","CUSTOM":"Custom","EXPORT":"Export","FILTER":"Filter","IMPORT":"Import","RECENT":"Recent","REJECT":"Reject","SEARCH":"searchnewnamespace","STATUS":"Status","TRANSIT":"Transit","COMPLETE":"Complete","IMPORTER":"Importer","CONTAINER":"Container","SHIPMENT_ID":"Shipment ID","ENTRY_NUMBER":"Entry Number","BILL_OF_LADING":"Bill Of Lading","PURCHASE_ORDER":"Purchase Order","SELECT_JOB_STATE":"Select Job State","SELECT_BROKER_NAME":"Select Broker Name","PRODUCT_DISCRIPTION":"Product Discritpion"}
// const languageBundle = (language, namespace) => {

//   accountAPI.getLangBundleByNamespc(language, namespace).then((response) =>{
//     resources[language] = {
//       [namespace]: response1,
//       translation: language
//     }
//   }).catch(() => {
//     resources[language] = {
//       [namespace]: response1,
//       "newNamespace": response2,
//       translation: language
//     }
//   })
// }

// const apiKey = "zQ8t3Y7QjCwSZwrqx1yytw";
// // const loadPath = `https://api.i18nexus.com/project_resources/translations/en/broker-search.json?api_key=${apiKey}`;
// const loadPath = languageBundle("en", "default")
// console.log("loadPath:", resources)
// // const resources = {
// //   en: {
// //     // Namspaces
// //     NCTSApp: enNCTS,
// //     Search: enSearch,
// //     translation: en,
// //   },
// //   de: {
// //     NCTSApp: deNCTS,
// //     Search: deSearch,
// //     translation: de,
// //   },
// //   nl: {
// //     NCTSApp: nlNCTS,
// //     Search: nlSearch,
// //     translation: nl,
// //   },
// //   es: {
// //     NCTSApp: esNCTS,
// //     Search: esSearch,
// //     translation: nl,
// //   },
// // };


// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     resources,
//     fallbackLng: 'en',
//     interpolation: {
//       escapeValue: false,
//     },
//   });

// export default i18n;

// // import i18next from "i18next";
// // import HttpBackend from "i18next-http-backend";
// // import LanguageDetector from "i18next-browser-languagedetector";
// // import { initReactI18next } from "react-i18next";

// // const apiKey = "zQ8t3Y7QjCwSZwrqx1yytw";
// // const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

// // i18next
// //   .use(HttpBackend)
// //   .use(LanguageDetector)
// //   .use(initReactI18next)
// //   .init({
// //     react: { 
// //       useSuspense: false
// //     },
// //     fallbackLng: "en",

// //     ns: ["default","broker-search"],
// //     defaultNS: "default",

// //     supportedLngs: ["en","es","nl","de"],
// //     interpolation: {
// //       escapeValue: false,
// //     },
// //     backend: {
// //       loadPath: loadPath
// //     }
// //   })


import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import moment from "moment";

const apiKey = "ycT3N5hxlEukcWkxrRnKrg";
const loadPath = (window._env_.I18NEXT_API_PATH).replace("qat", "stage");

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    react: { 
      useSuspense: false
    },
    interpolation: {
      formatSeparator: ',',
      format: function(value, formatting, lng){
        moment.locale(lng)
        if(lng === "en"){
          return moment.unix(value/1000).format("MMM Do, YYYY");
        } 
        else if(lng == "es"){
          return moment.unix(value/1000).format("DD [de] MMM YYYY")
        }
        return moment.unix(value / 1000).format("MMM Do, YYYY");
      }
    },
    initImmediate: false,
    fallbackLng: "en",
    ns: ["default","header","parties","lineItem","notes","valueBuildUp", "state_text", "transport"],
    defaultNS: "default",
    fallbackNS: ["header","parties","lineItem","notes","valueBuildUp", "state_text", "transport"],
    supportedLngs: ["en","es","de","nl"],
    backend: {
      loadPath: loadPath
    }
  })